import { FILE_SIZE_UNITS, BYTES_PER_UNIT } from './constants';

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const i = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_UNIT));
  return (
    Math.round((bytes / Math.pow(BYTES_PER_UNIT, i)) * 100) / 100 +
    " " +
    FILE_SIZE_UNITS[i]
  );
};

export const generateFileId = (fileName: string): string => {
  return `${fileName}-${Date.now()}-${Math.random()}`;
};


